import React from 'react'


const SecureString = ({value}) => {
    return value
}

export default SecureString